import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { LayoutService } from 'src/app/services';
import { TenantId } from 'src/environments/environments.types';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header-navbar',
  templateUrl: './header-navbar.component.html',
  styleUrls: ['./header-navbar.component.scss'],
})
export class HeaderNavbarComponent {
  @Input() isAdmin!: boolean;
  @Input() containsLinks = true;

  constructor(private layout: LayoutService) {}

  get tenant(): TenantId {
    return environment.tenant;
  }

  get isHandset$(): Observable<boolean> {
    return this.layout.isHandset$;
  }
}
